import { gql } from 'app/graphql';

export const CREATE_SAVED_SEARCH_CREATED_NOTIFICATION = gql(`
    mutation CreateSavedSearchNotification($input: CustomerCreatesSavedSearchInput!){
        notifications {
            events {
                savedSearchCreated(input: $input) {
                    id
                }
            }
        }
    }
`);